export default "__VITE_ASSET__ee812ebe__"